var i={avif:"image/avif",webp:"image/webp",original:void 0};export{i as FORMAT_MIME_TYPES};
//# sourceMappingURL=constants.js.map
